import React, { useContext } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import NewsFeed from "../components/NewsFeed";
import { AuthContext } from "../context/AuthContext";

import {
  Users,
  BarChart3,
  Boxes,
  Wallet,
  LineChart,
  Clock,
  Receipt,
  Handshake,
} from "lucide-react";

export default function HomePage() {
  const features = [
    { label: "Sales", icon: Users },
    { label: "Resource Planning", icon: BarChart3 },
    { label: "Project Management", icon: Boxes },
    { label: "Budgeting", icon: Wallet },
    { label: "Reporting", icon: LineChart },
    { label: "Time Tracking", icon: Clock },
    { label: "Billing", icon: Receipt },
    { label: "Collaboration", icon: Handshake },
  ];

  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();

  const boxVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  const handleGetStarted = () => {
    navigate("/register");
  };

  return (
    <div className="bg-gray-50 min-h-screen p-8">
      <div className="max-w-5xl mx-auto space-y-16">
        {/* Intro Section */}
        <div className="text-center space-y-6">
          <p className="text-sm text-[#2ecfe3] font-semibold uppercase tracking-wider">
            All-in-one Finance Management System
          </p>
          <h1 className="text-5xl font-bold leading-tight">
            We’re <span className="text-[#2ecfe3]">the Tool</span> for Financial
            Control
          </h1>
          <p className="text-lg text-gray-700 leading-relaxed">
            NeoFinance is your all-in-one solution for smart financial
            management. Choose what matters most to your growth:
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.label}
              className="flex items-center bg-white border border-gray-200 rounded-xl px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300"
              variants={boxVariants}
              initial="hidden"
              animate="visible"
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <feature.icon className="w-6 h-6 text-[#2ecfe3] mr-3" />
              <span className="font-medium text-base text-gray-800">
                {feature.label}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Finance News Showcase */}
        <NewsFeed />
      </div>
    </div>
  );
}
